import React from 'react';
import {
  renderApplicationStatus,
  renderAuditStatus,
  renderTime,
  renderEllipsis,
  renderNormalValue,
} from 'pages/manage/application/util';
interface TableProps {
  type?: any;
  name?: any;
  value?: any | number;
  data?: any;
  options?: any;
}

const getAllColumns = (
  listRef: any,
  hasOperationAuth: any,
  loadList: any,
  showEditDialog: (arg0: any, arg1: any) => void,
  showDetailDialog: (arg0: any, arg1: any) => void,
  showExportDialog: (arg0: any, arg1: any) => void,
  appStatusOptions: any,
  auditOptions: any
) => [
  {
    name: 'client_id',
    title: '应用ID',
    minWidth: 85,
    align: 'center',
    render: (type: TableProps, name: TableProps, value: any, data: any) => (
      <>
        <div>
          <a className="text-active" onClick={() => showDetailDialog(data.id, data.app_name)}>
            {value || '-'}
          </a>
        </div>
      </>
    ),
  },
  {
    name: 'app_name',
    title: '应用名称',
    sortable: false,
  },
  {
    name: 'category_string',
    title: '类型',
    sortable: false,
  },
  {
    name: 'app_desc',
    title: '应用描述',
    render: renderEllipsis,
  },
  {
    name: 'industry_name',
    title: '服务行业',
    sortable: false,
    render: renderNormalValue,
  },
  {
    name: 'audit_status',
    title: '审核状态',
    sortable: false,
    minWidth: 100,
    render: (type: TableProps, name: TableProps, value: TableProps, data: any) =>
      renderAuditStatus(type, name, value, data, auditOptions, false),
  },
  {
    name: 'status',
    title: '应用状态',
    sortable: false,
    render: (type: TableProps, name: TableProps, value: TableProps, data: any) =>
      renderApplicationStatus(type, name, value, data, appStatusOptions, false),
  },
  {
    name: 'created_by',
    title: '创建人',
    render: renderNormalValue,
  },
  {
    name: 'created_time',
    title: '创建时间',
    render: renderTime,
  },
  {
    name: 'shelfed_time',
    title: '上架时间',
    render: renderTime,
  },
  {
    name: 'operation',
    title: '操作',
    render: (type: TableProps, name: TableProps, value: TableProps, data: any) => {
      const { application_id: id = '' } = data;
      return (
        <>
          <a
            className="table-operation"
            target="_blank"
            onClick={() => showDetailDialog(data.id, data.app_name)}
            data-event-trace-delete={'详情'}
            data-event-extra-id={id}
          >
            详情
          </a>
          {/* <a */}
          {/*   className="table-operation" */}
          {/*   target="_blank" */}
          {/*   onClick={() => showExportDialog(data.client_id, data.app_name)} */}
          {/*   data-event-trace-edit={'编辑'} */}
          {/*   data-event-extra-id={id} */}
          {/* > */}
          {/*   编辑 */}
          {/* </a> */}
        </>
      );
    },
  },
];
export default (props: any) => {
  const {
    listRef,
    loadList,
    hasOperationAuth,
    showEditDialog,
    showDetailDialog,
    showExportDialog,
    appStatusOptions,
    auditOptions,
    // appCategoryOptions,
    // appSecondCategoryOptions,
  } = props;
  // 列配置映射

  const allColumns = getAllColumns(
    listRef,
    hasOperationAuth,
    loadList,
    showEditDialog,
    showDetailDialog,
    showExportDialog,
    appStatusOptions,
    auditOptions
  );

  return {
    emptyText: '暂无相关数据记录',
    enableFixedThead: true,
    columns: allColumns,
  };
};
